import React from "react";
import { QuestionAvatar, Separate, SpacingDiv } from "../../styles";
import { Typography } from "@mui/material";
import EditAndDelete from "../EditAndDelete";
import styled from "styled-components";
import QuestionImage from "./QuestionImage";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

const QuestionDetailsMC = ({
  question,
  handleDeleteQuestion,
  builderContext,
  isReview = false,
  isModuleLive,
  isModuleConvertingNextStateLive,
  isModuleConvertingNextStatePending,
  isModulePending,
  isModuleInReview,
  isModuleConvertingNextStateReview,
}) => (
  <Wrapper>
    <Typography
      style={{
        fontSize: 10,
        fontWeight: "500",
        color: "darkgrey",
        whiteSpace: "nowrap",
        alignSelf: "flex-start",
      }}
    >
      Multiple Choice
    </Typography>

    <div style={{ height: 8 }} />
    {["A", "B", "C", "D"].map((letter) => (
      <SpacingDiv key={letter}>
        <QuestionAvatar
          $isActive={question.correctAnswer.toUpperCase() === letter}
        >
          {letter}
        </QuestionAvatar>
        <Typography variant="body2">
          {question.options[letter.toLowerCase()]}
        </Typography>
      </SpacingDiv>
    ))}
    {!isReview && (
      <Separate>
        <div
          style={{
            minWidth: 200,
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <span
            style={{
              fontSize: 11,
              color: "black",
              whiteSpace: "nowrap",
              fontWeight: "600",
            }}
          >
            Correct Answer: {"  "}
            {question.correctAnswer.toUpperCase()}
          </span>
        </div>
        <EditAndDelete
          builderContext={builderContext}
          handleDeleteQuestion={handleDeleteQuestion}
          question={question}
          deleteDisabled={
            isModuleLive ||
            isModuleInReview ||
            isModuleConvertingNextStateReview ||
            isModulePending ||
            isModuleConvertingNextStateLive ||
            isModuleConvertingNextStatePending
          }
        />
      </Separate>
    )}
  </Wrapper>
);

export default QuestionDetailsMC;
